import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useReactiveVar } from '@apollo/client';
import { Dialog } from '@totalsoft/rocket-ui';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import { useListBrowserUtils } from '@ts-private/list-browser';
import { exportModalOpenVar } from './variables';
import ExportContainer from './ExportContainer';
import { useTranslation } from 'react-i18next';

const ExportModalComponent = ({ store, options }) => {
  const { t } = useTranslation();
  const { addActions } = useListBrowserUtils(store);
  const exportModalOpen = useReactiveVar(exportModalOpenVar);

  const setOpen = useCallback(value => () => exportModalOpenVar(value), []);

  useEffect(() => {
    addActions([
      {
        name: 'Export',
        label: t('ListBrowser.Export'),
        icon: <CloudDownloadIcon />,
        handler: setOpen(true)
      }
    ]);
  }, [t, setOpen, addActions]);

  return (
    <Dialog
      id='export-dialog'
      open={exportModalOpen}
      onClose={setOpen(false)}
      maxWidth='xs'
      title={t('ListBrowser.SelectExportType')}
      sx={{ '& .MuiDialogContent-root': { pb: 0 } }}
      closeButtonProps={{ sx: { display: 'none' } }}
      content={<ExportContainer store={store} options={options} />}
    />
  );
};

ExportModalComponent.propTypes = {
  store: PropTypes.object.isRequired,
  options: PropTypes.object
};

export default ExportModalComponent;
